import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import { Button } from "@material-ui/core";
import branchStyle from "assets/jss/material-dashboard-react/views/goldRatesStyle.js";
import FileUpload from "components/FileUpload/FileUpload";
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";
import { loanApplicationStatus } from "assets/properties/properties";
const useStyles = makeStyles(branchStyle);

const DocumentOld = ({
  setNext,
  setBack,
  loanApplicationId,
  props,
  editable,
  closeModal,
  status,
  newCustomer,
  existdocumentLink,
  classes,
  submitted,
  subStatus,
}) => {
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [showCameraImg, setShowCameraImg] = useState(false);
  const [showCameraImgCapture, setShowCameraImgCapture] = useState(false);
  const [showOrnamentCamera, setShowOrnamentCamera] = useState(false);
  const [showOrnamentCameraImg, setShowOrnamentCameraImg] = useState(false);
  const [
    showOrnamentCameraImgCapture,
    setShowOrnamentCameraImgCapture,
  ] = useState(false);
  const [customerImage, setCustomerImage] = useState("");
  const [customerImageUri, setCustomerImageUri] = useState("");
  const [ornamentImageUri, setOrnamentImageUri] = useState("");
  const [ornamentImage, setOrnamentImage] = useState("");
  const [documentImage1, setDocumentImage1] = useState("");
  const [documentImage1Capture, setDocumentImage1Capture] = useState(false);
  const [documentImage2, setDocumentImage2] = useState("");
  const [documentImage2Capture, setDocumentImage2Capture] = useState(false);
  const [documentImage3, setDocumentImage3] = useState("");
  const [documentImage3Capture, setDocumentImage3Capture] = useState(false);
  const [documentImage4, setDocumentImage4] = useState("");
  const [documentImage4Capture, setDocumentImage4Capture] = useState(false);
  const [documentImage5, setDocumentImage5] = useState("");
  const [documentImage5Capture, setDocumentImage5Capture] = useState(false);
  const [filedata, setFileData] = useState([]);
  const { ornamentDetail } = useSelector((state) => state.loanDetail?.ornamentDetail); 
  const [ornamentRcord, setOrnamentRecord] = useState(ornamentDetail);
  const { authToken } = useSelector((state) => state.login.authData);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const [callInProgress, setCallInProgress] = useState(false);
  let documentImage1Component = useRef();
  let documentImage2Component = useRef();
  let documentImage3Component = useRef();
  let documentImage4Component = useRef();
  let documentImage5Component = useRef();
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  //
  useEffect(() => {
    GetLoanOrnamentDetails();
  }, []);
  
  const GetLoanOrnamentDetails = async () => {
    if (ornamentRcord?.customerPhotoLinks && ornamentRcord?.customerPhotoLinks?.[0]) {
        setCustomerImage(decode(ornamentRcord?.customerPhotoLinks[0]));
      }
      if (ornamentRcord?.ornamentPhotoLinks && ornamentRcord?.ornamentPhotoLinks?.[0]) {
        setOrnamentImage(decode(ornamentRcord?.ornamentPhotoLinks?.[0]));
      }
      if (ornamentRcord?.documentPhotoLinks) {
        if (ornamentRcord?.documentPhotoLinks?.[0]) {
          setDocumentImage1(decode(ornamentRcord?.documentPhotoLinks?.[0]));
        }
        if (ornamentRcord?.documentPhotoLinks?.[1]) {
          setDocumentImage2(decode(ornamentRcord?.documentPhotoLinks?.[1]));
        }
        if (ornamentRcord?.documentPhotoLinks?.[2]) {
          setDocumentImage3(decode(ornamentRcord?.documentPhotoLinks?.[2]));
        }
        if (ornamentRcord?.documentPhotoLinks?.[3]) {
          setDocumentImage4(decode(ornamentRcord?.documentPhotoLinks?.[3]));
        }
        if (ornamentRcord?.documentPhotoLinks[4]) {
          setDocumentImage5(decode(ornamentRcord?.documentPhotoLinks?.[4]));
        }
      } else {
        if (newCustomer === false) {
          if (existdocumentLink) {
            if (existdocumentLink[0]) {
              setDocumentImage1(decode(existdocumentLink[0]));
            }
            if (existdocumentLink[1]) {
              setDocumentImage2(decode(existdocumentLink[1]));
            }
            if (existdocumentLink[2]) {
              setDocumentImage3(decode(existdocumentLink[2]));
            }
            if (existdocumentLink[3]) {
              setDocumentImage4(decode(existdocumentLink[3]));
            }
            if (existdocumentLink[4]) {
              setDocumentImage5(decode(existdocumentLink[4]));
            }
          }
        }
        // if New customer
        // Keep document blank/.... no action reqd
        // if existing customer
        // map existing document links to Document Image
      }
  };
  const onClickUploadPhoto = () => {
    setShowFileUpload(true);
    setShowCamera(false);
    setShowCameraImg(false);
  };
  const onClickCamera = () => {
    setShowFileUpload(false);
    setShowCamera(true);
    setShowCameraImg(false);
    setShowCameraImgCapture(true);
  };
  const onClickOrnamentCamera = () => {
    setShowOrnamentCamera(true);
    setShowOrnamentCameraImg(false);
    setShowOrnamentCameraImgCapture(true);
  };
  //
  const isValidated = () => {
    if(subStatus==="PRE_PLEDGE"){
      if (customerImage !== ""  && documentImage1 !== "") {
        return true;
      } else {
        return false;
      }
    }
    else {
      if (customerImage !== "" &&  ornamentImage !== "" && documentImage1 !== "") {
        return true;
      } else {
        return false;
      }
    }
  };
  const documentsubmit = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (isValidated()) {
      setCallInProgress(true);
      //ADMIN_DOCUMENT_UPDATELINKS
      const res = await apiHandler({
        url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
        method: "POST",
        authToken: authToken,
        data: {
          loanApplicationId: loanApplicationId,
          customerPhotoLinks: [customerImage.trim()],
          ornamentPhotoLinks: [ornamentImage.trim()],
          documentPhotoLinks: [
            documentImage1.trim(),
            documentImage2.trim(),
            documentImage3.trim(),
            documentImage4.trim(),
            documentImage5.trim(),
          ],
        },
      });
      setCallInProgress(false);
      if (res?.data?.error_code && res?.data?.error_code === 403) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return;
      } else {
        toastUpdate("Success","Create document successfully", true);
        handleCreateProfile();
        // STATUS UPDATE
        const status = await apiHandler({
            url: endpoint.SANCTION_STATUS_UPDATE,
            method: "PUT",
            authToken: authToken,
            data: {
              loanApplicationId: loanApplicationId,
              status: "SANCTIONED",
            },
          });
            closeModal('save');
      }
    } else {
      toastUpdate("Error", "Enter the Provide the document Details", true);
    }
  };
  const handleCreateProfile = async () => {
    setCallInProgress(true)
    const res = await apiHandler({
      url: endpoint.ADMIN_CREATE_PROFILE_NEW + loanApplicationId,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false)
    // setCustomerId(res?.data?.customerId);
    if (res?.data?.error_code === 500 || res?.data?.error_code) {
      toastUpdate("Error","Issue with Document Number. Available with different Customer ID", true);
    } else {
      toastUpdate("Success","Create Profile successfully", true);
      //setCustomerId(res?.data?.customerId);
      handleLoanApplicant(res?.data?.customerId);
    }
  };
  //
  const UploadFile = async (file, type) => {
    const formData = new FormData();
    formData.append("file", file, file.name);
    setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false)
    const uploadedPath = path.data;
    switch (type) {
      case "customer":
        setCustomerImage(uploadedPath.name);
        break;
      case "ornament":
        setOrnamentImage(uploadedPath.name);
        break;
      case "documentImage1":
        setDocumentImage1(uploadedPath.name);
        setDocumentImage1Capture(true);
        break;
      case "documentImage2":
        setDocumentImage2(uploadedPath.name);
        setDocumentImage2Capture(true);
        break;
      case "documentImage3":
        setDocumentImage3(uploadedPath.name);
        setDocumentImage3Capture(true);
        break;
      case "doumentImage4":
        setDocumentImage4(uploadedPath.name);
        setDocumentImage4Capture(true);
        break;
      case "documentImage5":
        setDocumentImage5(uploadedPath.name);
        setDocumentImage5Capture(true);
        break;
      default:
        break;
    }

    // handlecreateuserSubmit(uploadedPath.name);

    // setNext(); // kamal
  };
  const handleLoanApplicant = async (customerIds) => {
    setCallInProgress(true)
    //ADMIN_LOANACCOUNTNUMBER;
    const res = await apiHandler({
      url: endpoint.ADMIN_LOANACCOUNTNUMBER ,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: ornamentRcord.loanApplicationId || loanApplicationId,
        customerId: customerIds,
        newCustomer: newCustomer,
      },
    });
    setCallInProgress(false)
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success","Create LoanApplicant successfully", true);
      setNext();
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    //props.history.go(-1);
    setBack();
  };

  const fileInput = useRef();
  const onClickImportData = () => {
    fileInput.current.click();
  };
  const setFileUploaded = (dataParse) => {
    let bulkData = [];
    dataParse.forEach((dataRow, index) => {
      if (index !== 0) {
        if (dataRow[0]) bulkData.push(dataRow[0]);
      }
    });
    const uploadBulkData = async () => {
      let newPath = filedata;
      let name = filedata.path.substring(
        filedata.path.lastIndexOf("/") + 1,
        filedata.path.length
      );
      setCallInProgress(true)
      //ADMIN_FILE_UPLOADFILE
      const path = await apiHandler({
        url: endpoint.ADMIN_FILE_UPLOADFILE,
        method: "POST",
        authToken: authToken,
        data: {
          uri: newPath,
          name: name,
          type: filedata.mime,
        },
      });
      setCallInProgress(false)

      return path;
    };
    uploadBulkData();
  };
  const handleTakePhoto = async (dataUri, type) => {
    // Do stuff with the photo...
    // console.log("takePhoto", dataUri);
    setCallInProgress(true);
    switch (type) {
      case "CUSTOMER":
        setCustomerImageUri(dataUri);
        setShowFileUpload(false);
        setShowCamera(false);
        setShowCameraImg(true);
        break;
      case "ORNAMENT":
        setOrnamentImageUri(dataUri);
        setShowOrnamentCamera(false);
        setShowOrnamentCameraImg(true);
        break;
      default:
        setShowFileUpload(false);
        setShowCamera(false);
        setShowCameraImg(false);
        setShowOrnamentCamera(false);
        setShowOrnamentCameraImg(false);
    }
    //const formData = new FormData();
    const blob = await fetch(dataUri).then((res) => res.blob());
    UploadCameraFile(blob, type);
  };
  const UploadCameraFile = async (blob, type) => {
    const formData = new FormData();
    formData.append("file", blob, type);
    setCallInProgress(true)
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false)
    const uploadedPath = path.data;
    switch (type) {
      case "CUSTOMER":
        setCustomerImage(uploadedPath.name);
        break;
      case "ORNAMENT":
        setOrnamentImage(uploadedPath.name);
        break;
      default:
        break;
    }
    setCallInProgress(false);
  };
  const handleCameraError = (error) => {
    console.log("handleCameraError", error);
  };
  const handleCameraStart = (stream) => {
    console.log("handleCameraStart");
  };
  const handleCameraStop = () => {
    console.log("handleCameraStop");
  };
  //
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };
  // const decode = data => {
  //   console.log('DATA - ', data);
  //   var b=JSON.stringify(data);
  //   console.log('B - ', b);
  //   const str = b.replace(/\\/g, "");
  //   console.log('STR - ', str);
  //   return str;
  // };
  const decode = (str) => {
    // add another escaped slash if the string ends with an odd
    // number of escaped slashes which will crash JSON.parse
    let parsedStr = str.replace(/(^|[^\\])(\\\\)*\\$/, "$&\\");

    // escape unescaped double quotes to prevent error with
    // added double quotes in json string
    parsedStr = parsedStr.replace(/(^|[^\\])((\\\\)*")/g, "$1\\$2");

    try {
      parsedStr = JSON.parse(`"${parsedStr}"`);
    } catch (e) {
      return str;
    }
    return parsedStr;
  };
  return (
    <div>
      <GridContainer style={{ flexDirection: "row" }}>
        <GridItem xs={12} sm={12} md={6} lg={6} style={{ textAlign: "start" }}>
          <div style={{ fontWeight: "bold", fontSize: 20 }}>
            Document Capture
          </div>
        </GridItem>
      </GridContainer>
      <hr />
      <GridContainer style={{ marginTop: 40 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {editable === true && (
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Customer Photo</p>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  <Button
                    size="small"
                    // className="bg-gradient-theme-left border-0"
                    onClick={() => onClickCamera()}
                    // style={{marginLeft:"25px",textAlign:"center"}}
                  className={classes.nextButton1}
                    aria-label="upload report"
                  >
                    Camera
                  </Button>
                </GridItem>
              </GridContainer>
              <GridContainer>
                {showCamera && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Camera
                       style={{
                        width: "500px",
                        height: "500px",
                      }}
                      onTakePhoto={(dataUri) => {
                        handleTakePhoto(dataUri, "CUSTOMER");
                      }}
                      onCameraError={(error) => {
                        handleCameraError(error);
                      }}
                      isMaxResolution={true}
                      isFullscreen={false}
                      sizeFactor={2}
                      onCameraStart={(stream) => {
                        handleCameraStart(stream);
                      }}
                      onCameraStop={() => {
                        handleCameraStop();
                      }}
                    />
                  </GridItem>
                )}
                {/* {showCameraImg && (
                  <GridItem xs={3} sm={3} md={3} lg={3}>
                    <img src={customerImageUri} width="300" height="300" />
                  </GridItem>
                )} */}
                {customerImage !== "" && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={customerImage} width="200" height="200" alt="customerImage" />
                    <p style={{color:'green', fontWeight:700}}>Image saved successfully</p>
                  </GridItem>
                )}
              </GridContainer>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Ornament Photo</p>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12} >
                  <Button
                    size="small"
                    // className="bg-gradient-theme-left border-0"
                    onClick={() => onClickOrnamentCamera()}
                    // style={{marginLeft:"25px"}}
                  className={classes.nextButton1}
                    aria-label="upload report"
                  >
                    Camera
                  </Button>
                </GridItem>
                {showOrnamentCamera && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <Camera
                       style={{
                        width: "500px",
                        height: "500px",
                      }}
                      onTakePhoto={(dataUri) => {
                        handleTakePhoto(dataUri, "ORNAMENT");
                      }}
                      onCameraError={(error) => {
                        handleCameraError(error);
                      }}
                      isMaxResolution={true}
                      isFullscreen={false}
                      sizeFactor={2}
                      onCameraStart={(stream) => {
                        handleCameraStart(stream);
                      }}
                      onCameraStop={() => {
                        handleCameraStop();
                      }}
                    />
                  </GridItem>
                )}
                {ornamentImage !== "" && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={ornamentImage} width="200" height="200" alt="ornamentImage" />
                    <p style={{color:'green', fontWeight:700}}>Image saved successfully</p>
                  </GridItem>
                )}
              </GridContainer>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>
                {" "}
                Document Photo
              </p>
              <GridContainer>
                <GridItem xs={12} sm={12} md={1} lg={1} style={{marginBottom:10}}></GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{marginBottom:10}}>
                  <FileUpload
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    sendFile={(file) => UploadFile(file, "documentImage1")}
                    ref={documentImage1Component}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{marginBottom:10}}>
                  <FileUpload
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    sendFile={(file) => UploadFile(file, "documentImage2")}
                    ref={documentImage2Component}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{marginBottom:10}}>
                  <FileUpload
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    sendFile={(file) => UploadFile(file, "documentImage3")}
                    ref={documentImage3Component}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{marginBottom:10}}>
                  <FileUpload
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    sendFile={(file) => UploadFile(file, "documentImage4")}
                    ref={documentImage4Component}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2} lg={2} style={{marginBottom:10}}>
                  <FileUpload
                    addButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    changeButtonProps={{
                      color: brandTheme.buttonColor,
                      round: false,
                    }}
                    removeButtonProps={{
                      color: "danger",
                      round: false,
                    }}
                    supportedMimeType={[
                      "image/jpeg",
                      "image/bmp",
                      "image/png",
                      "image/tiff",
                    ]}
                    sendFile={(file) => UploadFile(file, "documentImage5")}
                    ref={documentImage5Component}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
              <GridItem xs={12} sm={12} md={1} lg={1}></GridItem>

                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage1 !== "" && !documentImage1Capture && (
                    <img src={documentImage1} width="200" height="200" alt="customerImage1"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage2 !== "" && !documentImage2Capture && (
                    <img src={documentImage2} width="200" height="200" alt="customerImage2"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage3 !== "" && !documentImage3Capture && (
                    <img src={documentImage3} width="200" height="200" alt="customerImage3"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage4 !== "" && !documentImage4Capture && (
                    <img src={documentImage4} width="200" height="200" alt="customerImage4" />
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage5 !== "" && !documentImage5Capture && (
                    <img src={documentImage5} width="200" height="200" alt="customerImage5"/>
                  )}
                </GridItem>
              </GridContainer>
            </GridItem>
          )}
          {editable === false && (
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Customer Photo</p>

              <GridContainer>
                {showCameraImg && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={customerImageUri} width="300" height="300" alt="customerImageUri"/>
                  </GridItem>
                )}
                {customerImage !== "" && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={customerImage} width="200" height="200" alt="customerImage"/>
                  </GridItem>
                )}
              </GridContainer>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Ornament Photo</p>
              <GridContainer>
                {showOrnamentCameraImg && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={customerImageUri} width="300" height="300" alt="OrnamentImageUri"/>
                  </GridItem>
                )}
                {ornamentImage !== "" && (
                  <GridItem xs={12} sm={12} md={12} lg={12}>
                    <img src={ornamentImage} width="200" height="200" alt="ornamnetImage"/>
                  </GridItem>
                )}
              </GridContainer>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>
                {" "}
                Document Photo
              </p>
              <GridContainer>
              <GridItem xs={12} sm={12} md={1} lg={1}></GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage1 !== "" && (
                    <img src={documentImage1} width="200" height="200" alt="documentImage1"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage2 !== "" && (
                    <img src={documentImage2} width="200" height="200" alt="documentImage2"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage3 !== "" && (
                    <img src={documentImage3} width="200" height="200" alt="documentImage3"/>
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage4 !== "" && (
                    <img src={documentImage4} width="200" height="200" alt="documentImage4" />
                  )}
                </GridItem>
                <GridItem xs={2} sm={2} md={2} lg={2}>
                  {documentImage5 !== "" && (
                    <img src={documentImage5} width="200" height="200" alt="documentImage5"/>
                  )}
                </GridItem>
              </GridContainer>
            </GridItem>
          )}

          {(status === loanApplicationStatus?.inProcess || status === loanApplicationStatus?.aadhaar || status === loanApplicationStatus?.selfie) ? (
            <GridContainer style={{ flexDirection: "row" }}>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: "end" }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                  
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress}
                  onClick={(event) => documentsubmit(event)}
                >
                  Submit
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} style={{ textAlign: "end" }}>
                <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                >
                  Back
                </Button>
                {!submitted && <Button
                  size="small"
                  className={classes.nextButton}
                  onClick={() => handlenext()}
                >
                  Next
                </Button>}
              </GridItem>
            </GridContainer>
          )}
        </GridItem>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
        {callInProgress && (
          <CircularProgresss callInProgress={callInProgress} />
        )}
      </GridContainer>
    </div>
  );
};

DocumentOld.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default DocumentOld;